import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import rest from '../axios';
import './css/popular.css';

const PopularItemsComponent = () => {
  const [popularItems, setPopularItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [newPopularItem, setNewPopularItem] = useState({ category_id: '', subcategory_id: '' });
  const [editPopularItem, setEditPopularItem] = useState({ id: '', category_id: '', subcategory_id: '' });
  const [loading, setLoading] = useState(false);
  const [showAddPopularModal, setShowAddPopularModal] = useState(false);
  const [showEditPopularModal, setShowEditPopularModal] = useState(false);
  const [showDeletePopularModal, setShowDeletePopularModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);


  useEffect(() => {
    setLoading(true);
    rest.get('/admin/categories')
      .then((response) => {
        const uniqueCategories = response?.data?.data?.filter((value, index, self) =>
          index === self.findIndex((t) => t.name === value.name)
        );
        setCategories(uniqueCategories);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao carregar categorias:', error);
        setLoading(false);
      });

    rest.get('/admin/populars')
      .then((response) => setPopularItems(response?.data?.data))
      .catch((error) => console.error('Erro ao carregar itens populares:', error));
  }, []);

  const loadSubcategories = (categoryId) => {
    setNewPopularItem({ ...newPopularItem, category_id: categoryId, subcategory_id: '' }); 
    rest.get(`/admin/subcategories/category/${categoryId}`)
      .then((response) => setSubcategories(response?.data?.data))
      .catch((error) => console.error('Erro ao carregar subcategorias:', error));
  };

  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    loadSubcategories(categoryId);
  };

  const handleSubcategoryChange = (e) => {
    const subcategoryId = e.target.value;
    setNewPopularItem({ ...newPopularItem, subcategory_id: subcategoryId });
  };

  const handleAddPopularItem = () => {
    setLoading(true);
    rest.post('/admin/populars', {
      categoryId: Number(newPopularItem.category_id),
      subcategoryId: Number(newPopularItem.subcategory_id)
    })
      .then(() => {
        setShowAddPopularModal(false);
        setNewPopularItem({ category_id: '', subcategory_id: '' });
        rest.get('/admin/populars')
          .then((response) => setPopularItems(response?.data?.data));
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao adicionar item popular:', error);
        setLoading(false);
      });
  };

  const handleEditPopularItem = () => {
    setLoading(true);
    rest.put(`/admin/populars/${editPopularItem.id}`, editPopularItem)
      .then(() => {
        setShowEditPopularModal(false);
        setEditPopularItem({ id: '', category_id: '', subcategory_id: '' });
        rest.get('/admin/populars')
          .then((response) => setPopularItems(response?.data?.data));
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao editar item popular:', error);
        setLoading(false);
      });
  };

  const handleDeletePopularItem = () => {
    setLoading(true);
    rest.delete(`/admin/populars/${deleteItemId}`)
      .then(() => {
        setShowDeletePopularModal(false);
        rest.get('/admin/populars')
          .then((response) => setPopularItems(response?.data?.data));
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao excluir item popular:', error);
        setLoading(false);
      });
  };

  return (
    <div className="containero                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                '">
      {/* Botão Adicionar Item Popular em cima da tabela */}
      <div className="mb-3">
        <Button className="btn btn-success" onClick={() => setShowAddPopularModal(true)}>
          Adicionar Item Popular
        </Button>
      </div>
      <div className="table-responsive">
        <table className="table mt-4">
          <thead>
            <tr>
              <th>Categoria</th>
              <th>Subcategoria</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {popularItems.length > 0 && popularItems.map((item) => (
              <tr key={item.id}>
                <td>{item.category.name}</td>
                <td>{item.subcategory.name}</td>
                <td>
                  <Button
                    className="btn btn-warning btn-sm me-2"
                    onClick={() => {
                      setEditPopularItem({ id: item.id, category_id: item.category.id, subcategory_id: item.subcategory.id });
                      setShowEditPopularModal(true);
                    }}
                  >
                    Editar
                  </Button>
                  <Button
                    className="btn btn-danger btn-sm"
                    onClick={() => {
                      setDeleteItemId(item.id);
                      setShowDeletePopularModal(true);
                    }}
                  >
                    Excluir
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal Adicionar Item Popular */}
      <Modal show={showAddPopularModal} onHide={() => setShowAddPopularModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Item Popular</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Categoria</Form.Label>
              <Form.Control
                as="select"
                value={newPopularItem.category_id}
                onChange={handleCategoryChange}
              >
                <option value="">Selecione uma categoria</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>{category.name}</option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label>Subcategoria</Form.Label>
              <Form.Control
                as="select"
                value={newPopularItem.subcategory_id}
                onChange={handleSubcategoryChange}
              >
                <option value="">Selecione uma subcategoria</option>
                {subcategories.map((subcategory) => (
                  <option key={subcategory.id} value={subcategory.id}>{subcategory.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddPopularModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleAddPopularItem}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Salvar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar Item Popular */}
      <Modal show={showEditPopularModal} onHide={() => setShowEditPopularModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Item Popular</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Categoria</Form.Label>
              <Form.Control
                as="select"
                value={editPopularItem.category_id}
                onChange={(e) => loadSubcategories(e.target.value)}
              >
                <option value="">Selecione uma categoria</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>{category.name}</option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label>Subcategoria</Form.Label>
              <Form.Control
                as="select"
                value={editPopularItem.subcategory_id}
                onChange={(e) => setEditPopularItem({ ...editPopularItem, subcategory_id: e.target.value })}
              >
                <option value="">Selecione uma subcategoria</option>
                {subcategories.map((subcategory) => (
                  <option key={subcategory.id} value={subcategory.id}>{subcategory.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditPopularModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleEditPopularItem}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Salvar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Excluir Item Popular */}
      <Modal show={showDeletePopularModal} onHide={() => setShowDeletePopularModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Item Popular</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Tem certeza de que deseja excluir este item?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeletePopularModal(false)}>Cancelar</Button>
          <Button variant="danger" onClick={handleDeletePopularItem}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Excluir'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PopularItemsComponent;
